import React from 'react';
import { View } from 'react-native';

import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  HeaderText,
  Button,
  PortalOverlay,
  PortalOverlayModal,
  PortalOverlayHeader,
  IButtonProps,
} from '../../../ui';
import { PortalOverlayProps } from '../../../ui/PortalOverlay/types';

type ProSettingsLayoutProps = {
  title?: string;
  name?: string;
  testID?: string;
  leftButtonProps?: Partial<IButtonProps>;
  rightButtonProps?: Partial<IButtonProps>;
  animationStyle?: PortalOverlayProps['animationStyle'];
  transparentOverlay?: PortalOverlayProps['isTransparent'];
  backgroundColor?: string;
};

const ProSettingsLayout: React.FC<ProSettingsLayoutProps> = ({
  children,
  title,
  name = 'pro_settings_layout',
  testID = 'ProSettings',
  leftButtonProps,
  rightButtonProps,
  animationStyle,
  transparentOverlay,
  backgroundColor = colors.whiteWash,
}) => (
  <PortalOverlay
    name={name}
    animationStyle={animationStyle}
    isTransparent={transparentOverlay}
  >
    <PortalOverlayModal
      position="fullScreen"
      color={backgroundColor}
      testID={testID}
    >
      <PortalOverlayHeader
        hideBottomBorder={title === undefined}
        renderLeftAction={leftButtonProps ? () => (
          <View>
            <Box
              paddingX={16}
              paddingY={6}
              testID={`${testID}--left`}
            >
              <Button
                size="medium"
                appearance="text"
                stopPropagation
                {...leftButtonProps}
                style={{ lineHeight: '33px', ...leftButtonProps.style }}
              />
            </Box>
          </View>
        ) : null}
        renderTitle={() => (
          <View>
            <HeaderText
              level="4"
              lineHeight={45}
              textAlign="center"
              style={{ fontWeight: '500' }}
              testID={`${testID}--title`}
            >
              {title}
            </HeaderText>
          </View>
        )}
        renderRightAction={rightButtonProps ? () => (
          <View>
            <Box
              paddingX={16}
              paddingY={6}
              testID={`${testID}--right`}
            >
              <Button
                size="medium"
                appearance="text-primary"
                style={{ lineHeight: '29px', padding: 0 }}
                stopPropagation
                {...rightButtonProps}
              />
            </Box>
          </View>
        ) : null}
      />
      {children}
    </PortalOverlayModal>
  </PortalOverlay>
);

export default ProSettingsLayout;
